export interface PersistedAuditResultRow {
  id?: string;
  key?: string;
  items?: unknown[];
  num_issues?: number;
  informativeOnly?: boolean;
  collectedParamCodes?: string[];
}

export interface PersistedAuditResultMeta {
  pass: number;
  fail: number;
  informative: number;
}

/** Persisted rows plus optional summary metadata attached on the array (audit mem shape). */
export type PersistedAuditResultsDisplay = PersistedAuditResultRow[] & {
  __metaData?: PersistedAuditResultMeta;
};

/** Summarize blocking / informative counts from a persisted S3 results payload. */
export const summarizePersistedAuditResults = (
  results: PersistedAuditResultRow[],
  itemId?: number,
): PersistedAuditResultMeta => {
  const meta: PersistedAuditResultMeta = { pass: 0, fail: 0, informative: 0 };

  for (const result of results ?? []) {
    let count = result.items?.length || result.num_issues || 0;
    if (itemId && count > 1) {
      count = 1;
    }
    if (!count) {
      meta.pass++;
    } else if (result.informativeOnly) {
      meta.informative += count;
    } else {
      meta.fail += count;
    }
  }

  return meta;
};

/**
 * Persisted logs are historical snapshots — do not strip rows using the *current*
 * profile assignment (warnings-only may exclude checks that were run on QC8).
 */
export const resultsForPersistedAuditLogDisplay = (
  results: PersistedAuditResultRow[],
): PersistedAuditResultsDisplay => {
  const rows = (results ?? []).filter((result) => !!(result?.id ?? result?.key));
  return rows as PersistedAuditResultsDisplay;
};
